import React from 'react';
import classNames from 'classnames';
import generateClassModifiers from '../../helpers/generate-class-modifiers';
const Stack = ({ children, gap = 'spacing-4-xs', breakpoints = undefined }) => {
  const spaceClass = generateClassModifiers('ws-ui-stack', { gap });
  const breakpointsSpacesClasses =
    breakpoints &&
    Object.keys(breakpoints).map((key) =>
      generateClassModifiers('ws-ui-stack', breakpoints[key], key)
    );

  const classes = classNames('ws-ui-stack', spaceClass, breakpointsSpacesClasses);
  return <div className={classes}>{children}</div>;
};

export default Stack;
